import { DateHelper } from "../../../../common/src";
import { SwedenCalendar } from "../../../../common/src/calendar/SwedenCalendar";

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

function previousBusinessDay(date: string): string {
    const calendar = new SwedenCalendar();
    let localDate = new Date(`${date}T00:00:00.000Z`);
    localDate = DateHelper.addDays(localDate, -1);
    if (calendar.isBusinessDay(localDate)) {
        return localDate.toISOString().substring(0, 10);
    }
    while (!calendar.isBusinessDay(localDate)) {
        localDate = DateHelper.addDays(localDate, -1);
    }
    return localDate.toISOString().substring(0, 10);
}

export function resolveFundParseDate(dateInput: string): string {
    const normalized = dateInput.trim();
    const lower = normalized.toLowerCase();
    const today = new Date();

    let resolved = normalized;
    if (lower === "today") {
        resolved = today.toISOString().substring(0, 10);
    } else if (lower === "yesterday") {
        resolved = DateHelper.addDays(today, -1).toISOString().substring(0, 10);
    } else if (lower === "previous") {
        resolved = previousBusinessDay(today.toISOString().substring(0, 10));
    } else if (lower === "previousmonth") {
        const firstOfMonth = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1));
        resolved = previousBusinessDay(firstOfMonth.toISOString().substring(0, 10));
    }

    if (!DATE_PATTERN.test(resolved)) {
        throw new Error(`Invalid date "${dateInput}". Use YYYY-MM-DD or one of: today, yesterday, previous, previousmonth.`);
    }

    return resolved;
}

export function fundParsePeriodCode(valuationDate: string): string {
    return valuationDate.replace(/-/g, "");
}
